import { useAuth } from "services/hook/Auth";

/**
 * Create markup html
 */
export const createMarkup = (text) => {
    return { __html: text };
}

/**
 * Get items for customer honorifics
 */
export const getHonorificsItems = () => {
    const honorifics = ['Mr', 'Ms', 'Mrs', 'Miss', 'Dr'];
    return honorifics;
};

/**
 * Build action items dynamically based on provided config
 */
export const getActionItems = (data, actions) => {
    const payloads = {
        detail: (item) => item,
        update: (item) => item.id,
        delete: (item) => item,
    };

    return Object.entries(actions)
        .filter(([, config]) => !!config)
        .map(([key, config]) => ({
            permission: config.permission,
            tooltip: config.tooltip,
            menu: config.menu,
            icon: config.icon,
            event: config.event,
            link: config.link,
            navigate: config.navigate,
            payload: payloads[key] ? payloads[key](data) : data.id,
        }));
};

/**
 * Get permission keys.
 */
export const getPermissionKeys = (type, extras = []) => {
    const { checkPermission } = useAuth();
    const base = {
        can_view: checkPermission(`${type}.view`),
        can_create: checkPermission(`${type}.create`),
        can_update: checkPermission(`${type}.update`),
        can_delete: checkPermission(`${type}.delete`),
    }
    const extra_perms = extras.reduce((item, key) => {
        item[`can_${key}`] = checkPermission(`${type}.${key}`);
        return item;
    }, {});

    return { ...base, ...extra_perms };
}

/**
 * Format a date string or Date object into a given pattern.
 */
export const formatDate = (date_input, format = 'dd-mm-yyyy', time_zone = 'Asia/Kolkata') => {
    if (!date_input) return '';

    let date;
    if (date_input instanceof Date) {
        date = date_input;
    } else {
        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(date_input)) {
            date = new Date(date_input.replace(' ', 'T') + 'Z');
        } else {
            date = new Date(date_input);
        }
    }

    if (isNaN(date)) return '';
    const options = { time_zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };
    const parts = new Intl.DateTimeFormat('en-GB', options).formatToParts(date);
    const map = Object.fromEntries(parts.map(p => [p.type, p.value]));

    const tokenMap = {
        dd: map.day,
        mm: map.month,
        yyyy: map.year,
        HH: map.hour,
        hh: String((+map.hour % 12) || 12).padStart(2, '0'),
        MM: map.minute,
        ss: map.second,
        A: +map.hour >= 12 ? 'PM' : 'AM',
    };

    return format.replace(/dd|mm|yyyy|HH|hh|MM|ss|A/g, token => tokenMap[token]);
};

